export const MUSIC_VARIABLE_SUGGESTIONS = [
    { label: '清空值', value: '${null}' },
    { label: '标题', value: '${title}' },
    { label: '艺术家', value: '${artist}' },
    { label: '首位艺术家', value: '${first_artist}' },
    { label: '首位艺术家首字母', value: '${first_artist_letter}' },
    { label: '专辑艺术家首字母', value: '${first_albumartist_letter}' },
    { label: '专辑', value: '${album}' },
    { label: '专辑艺术家', value: '${albumartist}' },
    { label: '碟号', value: '${discnumber}' },
    { label: '音轨号', value: '${tracknumber}' },
    { label: '文件名', value: '${filename}' },
    { label: '文件歌曲名', value: '${file_song_name}' },
    { label: '上级目录', value: '${parent_path}' },
    { label: '上上级目录', value: '${parent_parent_path}' },
    { label: '歌词', value: '${lyrics}' },
    { label: '备注', value: '${comment}' },
    { label: '年份', value: '${year}' },
    { label: '风格', value: '${genre}' },
    { label: '作曲', value: '${composer}' },
    { label: '作词', value: '${lyricist}' },
    { label: '计数器', value: '${counter}' }
]
